// Copyright 2018 Sorama B.V.

import { FileDownloader } from "libraries/FileDownloader/FileDownloader";
import { BrowserExportBase } from "./BrowserExportBase";
import { ImageFormat } from "./Format";

export class BrowserImageExport extends BrowserExportBase {
    private readonly svgImage: string;
    private readonly imageFormat: ImageFormat;

    constructor(imageFormat: ImageFormat, svgImage: string) {
        super(1920);
        this.svgImage = svgImage;
        this.imageFormat = imageFormat;
    }

    public export(fileName: string): Promise<void> {
        return super.rasterize(this.svgImage, this.imageFormat).then((x) => {
            FileDownloader.downloadBlobAsFile(
                new Blob([x]),
                "image/" + this.imageFormat.name.toLowerCase(),
                fileName + "." + this.imageFormat.name.toLowerCase()
            );
        });
    }

    public exportToBuffer(): Promise<ArrayBuffer> {
        return super.rasterize(this.svgImage, this.imageFormat).then((x) => {
            return x;
        });
    }
}
